interface ParticleProps {
  x: number
  y: number
  directionX: number
  directionY: number
  size: number
  color: string
}

export class Particle {
  private readonly _color: string
  private readonly _size: number

  private _directionX: number
  private _directionY: number

  constructor({ x, y, directionX, directionY, size, color }: ParticleProps) {
    this._x = x
    this._y = y
    this._directionX = directionX
    this._directionY = directionY
    this._color = color
    this._size = size
  }

  private _x: number

  get x(): number {
    return this._x
  }

  private _y: number

  get y(): number {
    return this._y
  }

  public getColorAfterReplace(opacity: number): string {
    return this._color.replace(/,0\.8\)/, `,${opacity})`)
  }

  // Mettre à jour la position de la particule
  public update(canvasRef: HTMLCanvasElement, ctx: CanvasRenderingContext2D) {
    if (this._x > canvasRef.width || this._x < 0) {
      this._directionX = -this._directionX
    }
    if (this._y > canvasRef.height || this._y < 0) {
      this._directionY = -this._directionY
    }
    this._x += this._directionX
    this._y += this._directionY
    this.draw(ctx)
  }

  // Dessiner une particule individuelle
  private draw(ctx: CanvasRenderingContext2D) {
    ctx.beginPath()
    ctx.arc(this._x, this._y, this._size, 0, Math.PI * 2, false)
    // Appliquer un effet de lueur
    ctx.shadowColor = this._color
    ctx.shadowBlur = 15
    ctx.fillStyle = this._color
    ctx.fill()
    // Réinitialiser l'ombre pour ne pas affecter les autres dessins
    ctx.shadowColor = 'transparent'
    ctx.shadowBlur = 0
  }
}
